import { createSelector } from 'reselect';

export const selectedIntervenantManagement = (state: any) => {
  return state.get('IntervenantManagement');
};

export const makeSelectMappingLawyers = () =>
  createSelector(selectedIntervenantManagement, state => {
    if (state && state.get('mappingLawyerJurisdiction')) {
      return state.get('mappingLawyerJurisdiction').toJS();
    }
    return [];
  });

export const makeSelectMappingLawyer = () =>
  createSelector(selectedIntervenantManagement, state => {
    if (state && state.get('mappingLawyer')) {
      return state.get('mappingLawyer').toJS();
    }
    return [];
  });
